// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e45u","content":"styles_content__3yJ4i"};